// src/pages/About.js
import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <div className="main-content">
        <div className="photo-section">
          <img src={require("../assets/joanna-photo.png")} alt="Joanna wearing a beige hat" />
        </div>

        <div className="text-section">
          <h2><span className="blue-text">Hi,</span><br />I'm Joanna</h2>
          
          <p>
            I'm an analyst, <span className="blue-text">problem-solver</span>, and someone 
            deeply passionate about creating user-centered designs. I thrive on bridging the gap between 
            technical constraints, business goals, and human behavior, bringing empathy into every project to 
            craft intuitive digital experiences that enrich people's lives.
          </p>

          <p>
            With a <strong>background</strong> in <span className="blue-text">design</span>, <span className="blue-text">art</span>, and a keen 
            interest in <span className="blue-text">psychology</span>, I'm fascinated by how 
            people think, interact, and make decisions. My journey has been driven by a desire to create 
            meaningful change and improve lives. UX design allows me to <strong>combine my skills, curiosity about 
            human behavior</strong>, and unique perspective to make a positive impact.
          </p>

          <p>
            Outside of work, I'm a traveler who <span className="blue-text">loves nature</span>, 
            hiking, yoga and connecting with people.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;